import { initializeApp } from "firebase/app"
import { getFunctions } from "firebase/functions";

// NOTE: this project uses Firebase for Hosting + Cloud Functions only.
// Authentication and all data access are handled by Supabase (see src/models/SupaBaseModel.js).
// Cloud Firestore has never been provisioned on the justcuts-web project.
const firebaseConfig = {
  apiKey: "AIzaSyBfGmHFsI6XODuaAAoDJzro4MygMxKgROs",
  authDomain: "justcuts-web.firebaseapp.com",
  projectId: "justcuts-web",
  storageBucket: "justcuts-web.appspot.com",
  messagingSenderId: "199554263122",
  appId: "1:199554263122:web:d9ac352e8d0a7b04e7d78b",
  measurementId: "G-RMF5NLVFL1"
};

const firebaseApp = initializeApp(firebaseConfig);

const functions = getFunctions(firebaseApp, "australia-southeast1");

export {
  functions
}
